import apiClient from './client';
import type { Domain, CreateDomainInput, UpdateDomainInput } from '@/types/domain';

// ========== DOMAINS API ==========

// Listar todos os domínios (com filtro opcional por projeto)
export const getDomains = async (): Promise<Domain[]> => {
    const response = await apiClient.get<Domain[]>('/domains');
    return response.data;
};

// Criar novo domínio
export const createDomain = async (data: CreateDomainInput): Promise<Domain> => {
    const response = await apiClient.post<Domain>('/domains', data);
    return response.data;
};

// Atualizar domínio
export const updateDomain = async (domainId: number, data: UpdateDomainInput): Promise<Domain> => {
    const response = await apiClient.put<Domain>(`/domains/${domainId}`, data);
    return response.data;
};

// Deletar domínio (soft delete)
export const deleteDomain = async (domainId: number): Promise<void> => {
    await apiClient.delete(`/domains/${domainId}`);
};

// Verificar disponibilidade de domínio
export const checkDomainAvailability = async (domainName: string): Promise<{ available: boolean; message: string }> => {
    const response = await apiClient.get<{ available: boolean; message: string }>(`/domains/check/${domainName}`);
    return response.data;
};

export async function getPreviewHtml(domain: string) {
    const response = await apiClient.post('/domains/preview', {
        domain: domain
    });
    return response.data;
}

